import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSearchCancel = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.875 9.812C18.8752 11.6046 18.3438 13.357 17.3481 14.8475C16.3523 16.3381 14.9368 17.4998 13.2807 18.1859C11.6247 18.872 9.80231 19.0516 8.04417 18.7019C6.28603 18.3522 4.67106 17.4891 3.40352 16.2215C2.13598 14.954 1.27279 13.339 0.923122 11.5809C0.573456 9.82272 0.753018 8.00037 1.4391 6.34428C2.12518 4.68819 3.28696 3.27275 4.77752 2.27697C6.26807 1.28119 8.02045 0.749802 9.81303 0.75C11.0031 0.75 12.1815 0.984396 13.2809 1.4398C14.3804 1.89521 15.3793 2.56271 16.2208 3.4042C17.0623 4.24568 17.7298 5.24467 18.1852 6.34412C18.6406 7.44358 18.875 8.62196 18.875 9.812Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.56799 6.56799L12.932 12.932"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.56799 12.932L12.932 6.56799"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2211 16.22L23.2501 23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSearchCancel.displayName = 'SvgSearchCancel';
export default SvgSearchCancel;
